/** @jsxImportSource theme-ui */
import React from 'react';
import { useSelector } from 'react-redux';

import {
  MapAggregationCat2AggregationDays,
  MapAggregationCat2TooltipLabel,
} from 'utils/modelHelpers';

import { Typography } from 'components/_common/Typography';
import { BdTooltip } from 'components/_controls/BdTooltip';
import { SparkTooltip } from 'components/_controls/DiseaseActivityControls/DaSparkTooltip';
import { BdSparkGraphBars } from 'components/_graphs/BdSparkGraph/BdSparkGraphBars';

import diseaseActivitiesTemporalSelectors from 'diseaseActivitiesTemporal/diseaseActivitiesTemporal.selectors';
import diseaseActivitiesTimeFrameSelectors from 'diseaseActivitiesTimeFrame/diseaseActivitiesTimeFrame.selectors';

import diseaseActivitiesGlobalSelectors from './diseaseActivitiesGlobal.selectors';

type SparkGraphGlobalProps = {
  diseaseId: number;
};

export const SparkGraphGlobal: React.FC<SparkGraphGlobalProps> = ({ diseaseId }) => {
  const timeframeStartDate = useSelector(
    diseaseActivitiesTimeFrameSelectors.timeframeStartDateAsDate
  );
  const graphData = useSelector(diseaseActivitiesTemporalSelectors.getGraphDataGlobal(diseaseId));
  const aggregationCat = useSelector(diseaseActivitiesTimeFrameSelectors.getAggregationCat);
  const reportedCases = useSelector(diseaseActivitiesGlobalSelectors.getReportedCases(diseaseId));

  return (
    <BdTooltip
      fixedWidth="175px"
      customPopup={
        <SparkTooltip
          isGlobal
          isLoading={!graphData}
          sumCases={reportedCases}
          timeframeStartDate={timeframeStartDate}
          aggregationDaysStr={MapAggregationCat2TooltipLabel[aggregationCat]}
        />
      }
    >
      <Typography variant="caption" color="deepSea50" marginBottom="8px" nowrap>
        Global case activity
      </Typography>
      <div sx={{ display: 'flex', justifyContent: 'flex-start' }} role="spark-graph">
        <BdSparkGraphBars
          width={92}
          height={60}
          graphData={graphData}
          aggregationDays={MapAggregationCat2AggregationDays[aggregationCat]}
          minDate={timeframeStartDate}
          isLoading={!graphData}
          isDateTicksUppercase
          padding={{
            left: 0,
            right: 0,
            top: 1,
            bottom: 20,
          }}
        />
      </div>
    </BdTooltip>
  );
};
